import {startTour as startDesktopTour} from "./smap-desktop";
import {startTour as startTabletTour} from "./smap-tablet";
import {startTour as startMobileTour} from "./smap-mobile";
import {TourStatus} from "./commands";
import Driver from 'driver.js'
import {debounce} from "../utility/debounce";
import {LoggingEvent} from "../services/IUsageLoggingService";
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;


export type TourFn = (driver?: Driver, startStepId?: string, restarted?: boolean) => TourStatus

function getCurrentTourFn(): TourFn {
    const width = window.innerWidth;
    if (width > 1024) {
        return startDesktopTour;
    } else if (width >= 768) {
        return startTabletTour;
    } else{
        return startMobileTour;
    }
}

/**
 * returns a promise that resolves the first time the tour is initiated
 */
export function startTour(mapService: IMapService): Promise<any> {
    let currentTourFn = getCurrentTourFn();
    let currentTourStatus = currentTourFn();

    // because we have different tours depending on screen size,
    // we want to change tours on the window resize event

    let handlingChange = false;

    const tourFnIfChanged = () => {
        const nextTourFn = getCurrentTourFn();
        return nextTourFn !== currentTourFn ? nextTourFn : null;
    };

    const onResize = debounce(() => {
        if (!handlingChange) {
            handlingChange = true;
            const driver = currentTourStatus().driver;
            if (!driver['isActivated']) {
                window.removeEventListener('resize', onResize);
                handlingChange = false;
                return;
            }

            const nextTourFn = tourFnIfChanged();
            if (nextTourFn) {
                // const currentStepIdx = <number> driver['currentStep'];
                // const currentStep = driver['steps'][currentStepIdx];
                // const stepId: string = currentStep && currentStep['options'] && currentStep['options']['_id'];;
                console.log('changing active tour due to resize');
                currentTourStatus = nextTourFn(driver, null, true);
                currentTourFn = nextTourFn
            }
        }
        handlingChange = false;
    }, 100);

    window.addEventListener('resize', onResize);

    const onOrientation = () => {
        const driver = currentTourStatus().driver;

        if (!driver || !driver['isActivated']) {
            window.removeEventListener('orientationchange', onOrientation);
            handlingChange = false;
            return;
        }

        setTimeout(onResize, 100);
    };

    window.addEventListener("orientationchange", onOrientation);

    // the following are used in logging usage to our logger and Google Analytics
    // notify others that the tour has started
    // const startTourEvent = new Event("TOUR_START");
    const startTourLoggingEvent = <LoggingEvent> new Event("LOG_EVENT");
    startTourLoggingEvent.category = "TOUR_START";
    window.dispatchEvent(startTourLoggingEvent);

    mapService.mapPromise.then(() => {
        mapService.tourActive = true;
    });

    const listeners: {[key: string]: any} = {};

    // notify others that the tour has been closed
    const doClose = () => {
        const loggingEvent = <LoggingEvent> new Event("LOG_EVENT");
        loggingEvent.category = "TOUR_CLOSE";
        window.dispatchEvent(loggingEvent);
        mapService.tourActive = false;
        Object.entries(listeners).forEach(([k, listener]) => {
            window.removeEventListener(k, listener);
        });
    }

    listeners['click'] = ev => {
        const target = ev.target;
        const classList = <DOMTokenList> target["classList"];
        if (classList.contains('driver-close-btn')) {
            doClose();
        }
    };

    listeners['keyup'] = (ev: KeyboardEvent) => {
        if (ev.key === 'Escape') {
            doClose();
        }
    };

    Object.entries(listeners).forEach(([k, listener]) => {
        window.addEventListener(k, listener);
    });

    return currentTourStatus().ready;
}
